export {useSimpleQuery} from './use-simple-query'
